import React, { useState } from "react";

import UserCommentComponent from "./userComment";
import NewCommentComponent from "./newComment";

import { CommentComponentWrapper } from "./styledComment";

const CommentComponent = ({
  simID,
  count,
  getCommentsError,
  commentsList,
  commentPageSizeUseState: [commentsPageSize, setCommentsPageSize],
  newCommentUseState,
  postCommentFunction,
  postCommentError,
  CheckAccessFunction,
}) => {
  const [isShowNewCommentForm, setIsShowNewCommnetForm] = useState(false);
  const handleAddNewCommentButton = (e) => {
    if (CheckAccessFunction(e)) setIsShowNewCommnetForm(true);
  };
  return (
    <CommentComponentWrapper className="d-flex flex-column mx-auto px-2">
      {!getCommentsError &&
        commentsList.slice(0, commentsPageSize).map((item, index) => {
          return <UserCommentComponent key={index} commentInfo={item} />;
        })}
      <div className="d-flex flex-column align-content-center my-5">
        {count === 0 && (
          <p className="text-center">برای این آزمایش نظری ثبت نشده است.</p>
        )}
        {count > 1 && !(count === commentsPageSize) && (
          <button
            className="more-comments-btn border-0 bg-transparent mb-5"
            onClick={() => {
              setCommentsPageSize((prevSize) => prevSize + 2);
            }}
          >
            مشاهده نظرات بیشتر
          </button>
        )}

        {!isShowNewCommentForm ? (
          <button
            name="add-comment-btn"
            className="add-comment-btn btn mx-auto"
            onClick={handleAddNewCommentButton}
          >
            افزودن نظر
          </button>
        ) : (
          <NewCommentComponent
            simID={simID}
            newCommentUseState={newCommentUseState}
            postCommentFunction={postCommentFunction}
            postCommentError={postCommentError}
          />
        )}
      </div>
    </CommentComponentWrapper>
  );
};

export default CommentComponent;
